import i18n from 'i18next';
import en_translation from './en.json';

import { initReactI18next } from 'react-i18next';
export const resources = {
  en: {
    translation: en_translation,
  },
} as const;

i18n.use(initReactI18next).init({
  // fallbackLng: Object.keys(resources),
  lng: 'en',
  fallbackLng: 'en',
  debug: false,
  returnObjects: true,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});
